import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=c9a9f112&"
import script from "./ItemDetail.vue?vue&type=script&lang=ts&"
export * from "./ItemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports